import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "flex flex-col h-full overflow-hidden bg-white" };
const _hoisted_2 = { class: "flex-shrink-0" };
const _hoisted_3 = { class: "flex items-start justify-between px-6 py-5" };
const _hoisted_4 = { class: "flex flex-col gap-1.5 min-w-0 flex-1" };
const _hoisted_5 = { class: "flex items-center gap-3" };
const _hoisted_6 = { class: "flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full bg-blue-50" };
const _hoisted_7 = { class: "min-w-0" };
const _hoisted_8 = { class: "text-base font-bold leading-tight text-gray-900" };
const _hoisted_9 = { class: "text-xs text-gray-400" };
const _hoisted_10 = { class: "flex items-center gap-2 pl-1" };
const _hoisted_11 = { class: "flex flex-col items-end flex-shrink-0 gap-2 ml-4" };
const _hoisted_12 = { class: "flex flex-col flex-1 overflow-y-auto" };
const _hoisted_13 = { class: "flex flex-col gap-4 px-6 py-5" };
const _hoisted_14 = { class: "flex items-center gap-2" };
const _hoisted_15 = { class: "text-sm font-bold text-gray-900" };
const _hoisted_16 = { class: "grid grid-cols-2 gap-3" };
const _hoisted_17 = { class: "flex flex-col gap-1 p-3 rounded-lg bg-gray-50" };
const _hoisted_18 = { class: "text-xs font-medium text-gray-400" };
const _hoisted_19 = { class: "text-sm font-semibold text-gray-900" };
const _hoisted_20 = { class: "flex flex-col gap-1 p-3 rounded-lg bg-gray-50" };
const _hoisted_21 = { class: "text-xs font-medium text-gray-400" };
const _hoisted_22 = { class: "text-sm font-semibold text-gray-900" };
const _hoisted_23 = { class: "flex flex-col gap-1 p-3 rounded-lg bg-gray-50" };
const _hoisted_24 = { class: "text-xs font-medium text-gray-400" };
const _hoisted_25 = { class: "text-sm font-semibold text-gray-900" };
const _hoisted_26 = { class: "flex flex-col gap-1 p-3 rounded-lg bg-gray-50" };
const _hoisted_27 = { class: "text-xs font-medium text-gray-400" };
const _hoisted_28 = { class: "text-sm font-semibold text-gray-900" };
const _hoisted_29 = {
    class: "flex flex-col gap-4 px-6 py-5",
    "data-testid": "booking-transport-details"
};
const _hoisted_30 = { class: "flex items-center gap-2" };
const _hoisted_31 = { class: "text-sm font-bold text-gray-900" };
const _hoisted_32 = { class: "grid grid-cols-2 gap-3" };
const _hoisted_33 = {
    key: 0,
    class: "flex flex-col gap-1 p-3 rounded-lg bg-gray-50"
};
const _hoisted_34 = { class: "flex items-center gap-1 text-xs font-medium text-gray-400" };
const _hoisted_35 = { class: "text-sm font-semibold text-gray-900" };
const _hoisted_36 = {
    key: 1,
    class: "flex flex-col gap-1 p-3 rounded-lg bg-gray-50"
};
const _hoisted_37 = { class: "flex items-center gap-1 text-xs font-medium text-gray-400" };
const _hoisted_38 = { class: "text-sm font-semibold text-gray-900" };
const _hoisted_39 = {
    key: 2,
    class: "flex flex-col gap-1 p-3 rounded-lg bg-gray-50"
};
const _hoisted_40 = { class: "flex items-center gap-1 text-xs font-medium text-gray-400" };
const _hoisted_41 = { class: "text-sm font-semibold text-gray-900" };
const _hoisted_42 = { class: "flex flex-col gap-4 px-6 py-5" };
const _hoisted_43 = { class: "flex items-center gap-2" };
const _hoisted_44 = { class: "text-sm font-bold text-gray-900" };
const _hoisted_45 = { class: "flex items-center gap-3 p-4 rounded-lg bg-gray-50" };
const _hoisted_46 = { class: "flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full bg-eorange-50" };
const _hoisted_47 = { class: "flex flex-col gap-0.5" };
const _hoisted_48 = { class: "flex items-center gap-2" };
const _hoisted_49 = { class: "text-sm font-semibold text-gray-900" };
const _hoisted_50 = { class: "text-xs text-gray-400" };
const _hoisted_51 = { class: "flex flex-col flex-1 gap-3 px-6 py-5 bg-yellow-50" };
const _hoisted_52 = { class: "flex items-center gap-2" };
const _hoisted_53 = { class: "text-sm font-bold text-gray-900" };
const _hoisted_54 = { class: "bg-yellow-100 rounded-lg p-3.5 border border-yellow-200" };
const _hoisted_55 = { class: "text-sm leading-relaxed text-gray-800" };
const _hoisted_56 = { class: "flex flex-col flex-1 gap-3 px-6 py-5" };
const _hoisted_57 = { class: "flex items-center gap-2" };
const _hoisted_58 = { class: "text-sm font-bold text-gray-900" };
const _hoisted_59 = { class: "bg-gray-50 rounded-lg p-3.5 border border-gray-200" };
const _hoisted_60 = { class: "text-sm leading-relaxed text-gray-800" };
import { computed } from "vue";
import { IconBus, IconCalendarEvent, IconClock, IconMapPin, IconX, IconCalendar, IconUsers, IconUser, IconNote, } from "@tabler/icons-vue";
import { reservationService } from "../services";
import { formatServiceDatetime } from "@/domains/shared/utils/date-utils";
import { useI18n } from "vue-i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BookingDetailDrawer',
    props: {
        booking: {}
    },
    emits: ["close"],
    setup(__props) {
        const props = __props;
        const { locale } = useI18n();
        const serviceName = computed(() => props.booking.serviceName || "—");
        const bookingReference = computed(() => reservationService.formatBookingReference(props.booking.id));
        const effectiveState = computed(() => reservationService.getDisplayStatus(props.booking));
        const serviceIconComponent = computed(() => reservationService.getServiceIcon(props.booking.serviceTypeCode) === "IconBus"
            ? IconBus
            : IconCalendarEvent);
        const transportDetails = computed(() => reservationService.getTransportDetails(props.booking));
        const stateLabel = computed(() => {
            locale.value;
            return reservationService.getState(effectiveState.value);
        });
        const stateBadgeClass = computed(() => reservationService.getStateBadgeClass(effectiveState.value));
        const stateDotClass = computed(() => reservationService.getStateDotClass(effectiveState.value));
        const formattedStartDate = computed(() => formatServiceDatetime(props.booking.startsAt));
        const formattedEndDate = computed(() => formatServiceDatetime(props.booking.endsAt));
        const formattedDuration = computed(() => {
            const ms = new Date(props.booking.endsAt).getTime() -
                new Date(props.booking.startsAt).getTime();
            const hours = Math.round(ms / 3_600_000);
            return `${hours} hora${hours !== 1 ? "s" : ""}`;
        });
        const clientFullName = computed(() => props.booking.customerName || "—");
        const notes = computed(() => props.booking.notes ?? "");
        const fulfillmentNotes = computed(() => props.booking.fulfillmentNotes ?? "");
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    (_openBlock(), _createBlock(_resolveDynamicComponent(serviceIconComponent.value), { class: "w-5 h-5 text-blue-600" }))
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("p", _hoisted_8, _toDisplayString(serviceName.value), 1),
                                    _createElementVNode("p", _hoisted_9, _toDisplayString(bookingReference.value), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(["inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold", stateBadgeClass.value])
                                }, [
                                    _createElementVNode("span", {
                                        class: _normalizeClass(["w-1.5 h-1.5 rounded-full", stateDotClass.value])
                                    }, null, 2),
                                    _createTextVNode(" " + _toDisplayString(stateLabel.value), 1)
                                ], 2)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "flex items-center justify-center w-8 h-8 transition-colors rounded-lg bg-gray-50 hover:bg-gray-100",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                            }, [
                                _createVNode(_unref(IconX), { class: "w-4 h-4 text-gray-500" })
                            ])
                        ])
                    ]),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "h-px bg-gray-100" }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            _createVNode(_unref(IconCalendar), { class: "w-4 h-4 text-eorange-500" }),
                            _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t("reservations.auto.detalles_de_la_reserva")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("reservations.auto.fecha_de_inicio")), 1),
                                _createElementVNode("span", _hoisted_19, _toDisplayString(formattedStartDate.value), 1)
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("reservations.auto.fecha_de_fin")), 1),
                                _createElementVNode("span", _hoisted_22, _toDisplayString(formattedEndDate.value), 1)
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("reservations.auto.duracion")), 1),
                                _createElementVNode("span", _hoisted_25, _toDisplayString(formattedDuration.value), 1)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("reservations.auto.participantes")), 1),
                                _createElementVNode("span", _hoisted_28, _toDisplayString(__props.booking.partySize) + " adultos", 1)
                            ])
                        ])
                    ]),
                    (transportDetails.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "h-px bg-gray-100" }, null, -1)),
                            _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                    _createVNode(_unref(IconBus), { class: "w-4 h-4 text-eorange-500" }),
                                    _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.$t("reservations.transport.title")), 1)
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                    (transportDetails.value.pickupLocation)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                            _createElementVNode("span", _hoisted_34, [
                                                _createVNode(_unref(IconMapPin), { class: "w-3.5 h-3.5" }),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t("itinerary.form.pickup_location")), 1)
                                            ]),
                                            _createElementVNode("span", _hoisted_35, _toDisplayString(transportDetails.value.pickupLocation), 1)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (transportDetails.value.pickupTime)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                            _createElementVNode("span", _hoisted_37, [
                                                _createVNode(_unref(IconClock), { class: "w-3.5 h-3.5" }),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t("itinerary.form.pickup_time")), 1)
                                            ]),
                                            _createElementVNode("span", _hoisted_38, _toDisplayString(transportDetails.value.pickupTime), 1)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (transportDetails.value.dropoffLocation)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                            _createElementVNode("span", _hoisted_40, [
                                                _createVNode(_unref(IconMapPin), { class: "w-3.5 h-3.5" }),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t("itinerary.form.dropoff_location")), 1)
                                            ]),
                                            _createElementVNode("span", _hoisted_41, _toDisplayString(transportDetails.value.dropoffLocation), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ], 64))
                        : _createCommentVNode("", true),
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "h-px bg-gray-100" }, null, -1)),
                    _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                            _createVNode(_unref(IconUsers), { class: "w-4 h-4 text-eorange-500" }),
                            _createElementVNode("h3", _hoisted_44, _toDisplayString(_ctx.$t("reservations.auto.informacion_de_contacto")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                                _createVNode(_unref(IconUser), { class: "w-4.5 h-4.5 text-eorange-500" })
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("span", _hoisted_49, _toDisplayString(clientFullName.value), 1)
                                ]),
                                _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t("reservations.auto.huesped")), 1)
                            ])
                        ])
                    ]),
                    (notes.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "h-px bg-gray-100" }, null, -1)),
                            _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("div", _hoisted_52, [
                                    _createVNode(_unref(IconNote), { class: "w-4 h-4 text-yellow-600" }),
                                    _createElementVNode("h3", _hoisted_53, _toDisplayString(_ctx.$t("reservations.auto.notas")), 1)
                                ]),
                                _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("p", _hoisted_55, _toDisplayString(notes.value), 1)
                                ])
                            ])
                        ], 64))
                        : _createCommentVNode("", true),
                    (fulfillmentNotes.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "h-px bg-gray-100" }, null, -1)),
                            _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("div", _hoisted_57, [
                                    _createVNode(_unref(IconNote), { class: "w-4 h-4 text-eorange-500" }),
                                    _createElementVNode("h3", _hoisted_58, _toDisplayString(_ctx.$t("reservations.auto.notas_de_cumplimiento")), 1)
                                ]),
                                _createElementVNode("div", _hoisted_59, [
                                    _createElementVNode("p", _hoisted_60, _toDisplayString(fulfillmentNotes.value), 1)
                                ])
                            ])
                        ], 64))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
